interface WaveSeparatorProps {
  className?: string
  reverse?: boolean
  top?: boolean
}

const WaveSeparator = ({ className = "", reverse = false, top = false }: WaveSeparatorProps) => {
  const classes = `wave-separator ${reverse ? 'reverse' : ''} ${top ? 'top' : ''} ${className}`
  
  return (
    <div className={classes} aria-hidden="true" />
  )
}

export default WaveSeparator